module.exports = __webpack_public_path__ + "static/media/64.800236f1.jpg";